<span
    title="{{ assignedUser?.userName }}"
    class="text-nowrap"
    [ngStyle]="{ cursor: isEditable ? 'pointer' : 'inherit' }"
    (click)="showAssignableUserEditModal()"
    [attr.data-testid]="'show_Assignable_User_Edit_Modal_button_' + uid"

>
    <div *ngIf="!assignedUser">-</div>
    <app-mazars-profile-picture *ngIf="assignedUser" [mode]="mode" [user]="assignedUser" [uid]="uid + '-profile-picture-' + assignedUser?.id"></app-mazars-profile-picture>
</span>

<app-mazars-assignable-user-select-edit-modal #mazarsAssignableEditModal *ngIf="isEditable" [uid]="uid"></app-mazars-assignable-user-select-edit-modal>
